import { Button, Form, Image, Row, Col, Container } from "react-bootstrap";
import AuthenticationLayout from "../../lib/components/layouts/authentication";
import FlexBox from "../../lib/components/common/flex-box";
import AuthenticationForm from "../../lib/components/authentication/authentication-form";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { USER_ROLES } from "../../lib/constants";
import {
  EMAIL_VALIDATION_SCHEMA,
  PASSWORD_VALIDATION_SCHEMA,
  SIGN_IN_VALIDATION_SCHEME,
} from "../../lib/constants/validation-constants";

import Hyperlink from "lib/components/common/hyperlink";
import useAuthentication from "lib/hooks/useAuthentication";
import ErrorBox from "lib/components/common/error-box";
import SimplePasswordField from "lib/components/common/simple-password";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { DEFAULT_LOGIN_VALUES } from "lib/constants/default-values";
import { ASSETS } from "assets";
import SimpleTextbox from "lib/components/common/simple-textbox";
import ReCAPTCHA from "react-google-recaptcha";
import useLocalStorage from "lib/hooks/useLocalStorage";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_V2_SITE_KEY || '';

const SignIn = () => {
  const navigate = useNavigate();
  const { signInUser, error, loading } = useAuthentication();
  const { clearAll } = useLocalStorage();


  const onSignInSuccess = (role: string) => {
    switch (role) {
      case USER_ROLES.SUPER:
      case USER_ROLES.ADMIN:
      case USER_ROLES.RECEPTIONIST:
        navigate(PAGE_ROUTES.ADMIN.Dashboard);
        break;
      case USER_ROLES.PATIENT:
        // navigate(PAGE_ROUTES.PATIENT.Dashboard);
        clearAll();
        navigate('/')
        break;
      case USER_ROLES.PRACTITIONER:
        clearAll();
        navigate('/')
        // navigate(PAGE_ROUTES.PRACTITIONER.Dashboard);
        break;
      default:
        navigate(PAGE_ROUTES.Root);
        break;
    }
  };

  return (
    <AuthenticationLayout>
      <Container fluid className="overflow-hidden">
        <Row className="vh-100">
          <Col
            lg={8}
            className="d-none d-lg-flex align-items-center justify-content-center"
          >
            <Image
              src={ASSETS.IMAGES.LOGIN_IMAGE}
              alt="Sign In"
              className="img-fluid login-image max-width-500"
            />
          </Col>
          <Col lg={4} md={12} className="d-flex align-items-center">
            <AuthenticationForm isLoading={loading} className="w-100 px-4">
              <FlexBox justifyContent="start" className="mb-4">
                <h2>Login</h2>
              </FlexBox>

              <Formik
                initialValues={{ ...DEFAULT_LOGIN_VALUES, recaptchaToken: "" }}
                validationSchema={SIGN_IN_VALIDATION_SCHEME}
                onSubmit={(values: LoginRequest) => {
                  if (!values.recaptchaToken) {
                    alert("Please verify you are not a robot.");
                    return;
                  }
                  signInUser(values, onSignInSuccess);
                }}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  errors,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit} className="w-100">
                    <SimpleTextbox
                      label="Email address"
                      type="email"
                      name="email"
                      value={values.email}
                      className="form-control mb-3"
                      onChange={handleChange}
                      required
                      validationSchema={EMAIL_VALIDATION_SCHEMA}
                      error={typeof errors.email === "string" ? errors.email : error || ""}
                    />
                    <SimplePasswordField
                      label="Password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      required
                      isShowVisibilityIcon
                      className="mb-3"
                      validationSchema={PASSWORD_VALIDATION_SCHEMA}
                      error={typeof errors.password === "string" ? errors.password : error || ""}
                    />

                    {/* Add reCAPTCHA */}
                    <div className="mb-3 text-center">
                      <ReCAPTCHA
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={(token) =>
                          setFieldValue("recaptchaToken", token)
                        }
                      />
                    </div>

                    <FlexBox
                      justifyContent="end"
                      alignItems="center"
                      className="mb-3"
                    >
                      <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.ForgotPassword}>
                        Forgot Password?
                      </Hyperlink>
                    </FlexBox>
                    {error && <ErrorBox message={error} />}
                    <Form.Group className="form-group mb-4 text-center">
                      <Button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary py-2 px-4"
                      >
                        Login
                      </Button>
                    </Form.Group>
                  </Form>
                )}
              </Formik>
              <div className="text-center">
                <p className="mb-2">
                  New Patient?{" "}
                  <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.SignUp}>
                    Sign Up
                  </Hyperlink>
                </p>
                <p className="mb-0">
                  Are you a practitioner?{" "}
                  <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.PractitionerSignUp}>
                    Enrol as Practitioner
                  </Hyperlink>
                </p>
              </div>
            </AuthenticationForm>
          </Col>
        </Row>
      </Container>
    </AuthenticationLayout>
  );
};

export default SignIn;
